import React, { useState } from 'react'
import { Icon, l, PrimaryNavigation } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { useMediaQuery } from 'utils/commonHooks'
import { getIconSiteUrl } from 'utils/url'

import { ICON_WINDOW_TARGET } from '../constants'
import { FusionAnalytics } from '../lib/fusionAnalytics'
import { getShouldShowFusionSidebarLink, getShouldShowIconToClassicWelcome } from '../selectors'

import { IconToClassicWelcomeTooltip } from './IconToClassicWelcomeTooltip'
import iconLogo from './icon_sidebar_logo.svg'

import * as cm from './FusionSidebarLink.module.css'

interface FusionSidebarLinkProps {
  collapsed: boolean
}

export const FusionSidebarLink = ({ collapsed }: FusionSidebarLinkProps) => {
  const shouldShowFusionSidebarLink = useAppSelector(getShouldShowFusionSidebarLink)
  const isWelcomeRequested = useAppSelector(getShouldShowIconToClassicWelcome)
  // Same breakpoint as the sidebar: below it the sidebar is a drawer, so the tooltip has nothing to point at
  const isMobile = useMediaQuery('(max-width: 900px)')
  const shouldShowWelcome = isWelcomeRequested && !isMobile
  // State instead of refs: the tooltip has to re-render once its anchor is in the DOM
  const [linkElement, setLinkElement] = useState<HTMLElement | null>(null)
  const [labelElement, setLabelElement] = useState<HTMLElement | null>(null)
  // The collapsed sidebar doesn't render the label, so the tooltip points at the whole link there
  const welcomeAnchor = collapsed ? linkElement : labelElement

  if (!shouldShowFusionSidebarLink) {
    return null
  }

  const handleClick = () => {
    FusionAnalytics.logSidebarLinkClick()
  }

  return (
    <>
      <PrimaryNavigation.Item
        ref={setLinkElement}
        as="a"
        href={getIconSiteUrl()}
        target={ICON_WINDOW_TARGET as '_blank'}
        icon={<img src={iconLogo} className={cm.logo} alt="" aria-hidden="true" />}
        ariaLabel={l.translate(
          '<l10n context="Icon by Manychat is untranslatable"/>Icon by Manychat',
        )}
        tooltip={l.translate('<l10n context="Icon is untranslatable"/>Icon')}
        collapsed={collapsed}
        className="m-l-xxs"
        onClick={handleClick}
        data-test-id="icon-nav-item"
      >
        <span ref={setLabelElement} className={cm.label}>
          <span>{l.translate('<l10n context="Icon is untranslatable"/>Icon')}</span>
          <Icon.ArrowTopRight size={16} />
        </span>
      </PrimaryNavigation.Item>
      {shouldShowWelcome && <IconToClassicWelcomeTooltip anchor={welcomeAnchor} />}
    </>
  )
}
